"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonyDealer = exports.loadColoniesFromJSON = exports.getColonyByName = exports.COMMUNITY_COLONIES_TILES = exports.ALL_COLONIES_TILES = void 0;
const Europa_1 = require("./Europa");
const Ganymede_1 = require("./Ganymede");
const Titan_1 = require("./Titan");
const Callisto_1 = require("./Callisto");
const Triton_1 = require("./Triton");
const Ceres_1 = require("./Ceres");
const Luna_1 = require("./Luna");
const Io_1 = require("./Io");
const Miranda_1 = require("./Miranda");
const Pluto_1 = require("./Pluto");
const Enceladus_1 = require("./Enceladus");
const Iapetus_1 = require("../cards/community/colonies/Iapetus");
const Mercury_1 = require("../cards/community/colonies/Mercury");
const ColonyName_1 = require("./ColonyName");
const Hygiea_1 = require("../cards/community/colonies/Hygiea");
const Titania_1 = require("../cards/community/colonies/Titania");
const Venus_1 = require("../cards/community/colonies/Venus");
const Leavitt_1 = require("../cards/community/colonies/Leavitt");
const Pallas_1 = require("../cards/community/colonies/Pallas");
const Deimos_1 = require("../cards/community/colonies/Deimos");
const Terra_1 = require("../cards/community/colonies/Terra");
const Kuiper_1 = require("../cards/community/colonies/Kuiper");
exports.ALL_COLONIES_TILES = [
    { colonyName: ColonyName_1.ColonyName.CERES, Factory: Ceres_1.Ceres },
    { colonyName: ColonyName_1.ColonyName.ENCELADUS, Factory: Enceladus_1.Enceladus },
    { colonyName: ColonyName_1.ColonyName.EUROPA, Factory: Europa_1.Europa },
    { colonyName: ColonyName_1.ColonyName.GANYMEDE, Factory: Ganymede_1.Ganymede },
    { colonyName: ColonyName_1.ColonyName.IO, Factory: Io_1.Io },
    { colonyName: ColonyName_1.ColonyName.LUNA, Factory: Luna_1.Luna },
    { colonyName: ColonyName_1.ColonyName.MIRANDA, Factory: Miranda_1.Miranda },
    { colonyName: ColonyName_1.ColonyName.TITAN, Factory: Titan_1.Titan },
    { colonyName: ColonyName_1.ColonyName.CALLISTO, Factory: Callisto_1.Callisto },
    { colonyName: ColonyName_1.ColonyName.PLUTO, Factory: Pluto_1.Pluto },
    { colonyName: ColonyName_1.ColonyName.TRITON, Factory: Triton_1.Triton },
];
exports.COMMUNITY_COLONIES_TILES = [
    { colonyName: ColonyName_1.ColonyName.IAPETUS, Factory: Iapetus_1.Iapetus },
    { colonyName: ColonyName_1.ColonyName.MERCURY, Factory: Mercury_1.Mercury },
    { colonyName: ColonyName_1.ColonyName.HYGIEA, Factory: Hygiea_1.Hygiea },
    { colonyName: ColonyName_1.ColonyName.TITANIA, Factory: Titania_1.Titania },
    { colonyName: ColonyName_1.ColonyName.VENUS, Factory: Venus_1.Venus },
    { colonyName: ColonyName_1.ColonyName.LEAVITT, Factory: Leavitt_1.Leavitt },
    { colonyName: ColonyName_1.ColonyName.PALLAS, Factory: Pallas_1.Pallas },
    { colonyName: ColonyName_1.ColonyName.DEIMOS, Factory: Deimos_1.Deimos },
    { colonyName: ColonyName_1.ColonyName.TERRA, Factory: Terra_1.Terra },
    { colonyName: ColonyName_1.ColonyName.KUIPER, Factory: Kuiper_1.Kuiper },
];
function getColonyByName(colonyName) {
    const colonyTiles = exports.ALL_COLONIES_TILES.concat(exports.COMMUNITY_COLONIES_TILES);
    const colonyFactory = colonyTiles.find((colonyFactory) => colonyFactory.colonyName === colonyName);
    if (colonyFactory !== undefined) {
        return new colonyFactory.Factory();
    }
    return undefined;
}
exports.getColonyByName = getColonyByName;
function loadColoniesFromJSON(colonies) {
    const result = [];
    for (const serialized of colonies) {
        const colony = getColonyByName(serialized.name);
        if (colony !== undefined) {
            colony.isActive = serialized.isActive;
            colony.visitor = serialized.visitor;
            colony.trackPosition = serialized.trackPosition;
            colony.colonies = serialized.colonies;
            colony.resourceType = serialized.resourceType;
            result.push(colony);
        }
        else {
            console.warn(`colony ${serialized.name} not found`);
        }
    }
    return result;
}
exports.loadColoniesFromJSON = loadColoniesFromJSON;
class ColonyDealer {
    constructor() {
        this.coloniesDeck = [];
        this.discardedColonies = [];
    }
    static shuffle(cards) {
        const deck = [];
        const copy = cards.slice();
        while (copy.length) {
            deck.push(copy.splice(Math.floor(Math.random() * copy.length), 1)[0]);
        }
        return deck;
    }
    discard(card) {
        this.discardedColonies.push(card);
    }
    drawColonies(players, gameOptions, addCommunityColonies = false) {
        const allowList = gameOptions.customColoniesList || [];
        const venusNextExtension = gameOptions.venusNextExtension;
        const turmoilExtension = gameOptions.turmoilExtension;
        const aresExtension = gameOptions.aresExtension;
        const promoCardsOption = gameOptions.promoCardsOption;
        let count = players + 2;
        let colonyTiles = exports.ALL_COLONIES_TILES;
        if (addCommunityColonies)
            colonyTiles = colonyTiles.concat(exports.COMMUNITY_COLONIES_TILES);
        if (!venusNextExtension)
            colonyTiles = colonyTiles.filter((c) => c.colonyName !== ColonyName_1.ColonyName.VENUS);
        if (!turmoilExtension)
            colonyTiles = colonyTiles.filter((c) => c.colonyName !== ColonyName_1.ColonyName.PALLAS);
        if (!aresExtension)
            colonyTiles = colonyTiles.filter((c) => c.colonyName !== ColonyName_1.ColonyName.DEIMOS);
        if (!promoCardsOption)
            colonyTiles = colonyTiles.filter((c) => c.colonyName !== ColonyName_1.ColonyName.KUIPER);
        if (allowList.length === 0) {
            colonyTiles.forEach((e) => allowList.push(e.colonyName));
        }
        if (players === 1) {
            count = 4;
        }
        else if (players === 2) {
            count = 5;
        }
        const tempDeck = ColonyDealer.shuffle(colonyTiles.filter((el) => allowList.includes(el.colonyName)).map((cf) => new cf.Factory()));
        for (let i = 0; i < count; i++) {
            this.coloniesDeck.push(tempDeck.pop());
        }
        this.discardedColonies.push(...tempDeck);
        this.discardedColonies.sort((a, b) => (a.name > b.name) ? 1 : -1);
        this.coloniesDeck.sort((a, b) => (a.name > b.name) ? 1 : -1);
        return this.coloniesDeck;
    }
}
exports.ColonyDealer = ColonyDealer;
//# sourceMappingURL=ColonyDealer.js.map